// extracted by mini-css-extract-plugin
export default {"main":"StudentCompany_main__AZa85","company":"StudentCompany_company__BcMiZ","companies":"StudentCompany_companies__dO7ze"};